type Props = {
  onClick: () => void;
};

export const Overlay = ({ onClick }: Props) => (
  <div className="overlay" onClick={onClick}></div>
);
